(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$tur$pay = svs.tur.pay,
  dialogs = _svs$tur$pay.dialogs,
  accountServices = _svs$tur$pay.account_services,
  apiCalls = _svs$tur$pay.api_calls,
  communication = _svs$tur$pay.communication,
  initPay = _svs$tur$pay.initPay;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const getLocalizedWeekday = svs.utils.date.getLocalizedWeekday;
const PRICE_PER_WEEK = 40;
const _svs$tur$pay_lyckopla = svs.tur.pay_lyckoplatsen,
  playNextDrawDialog = _svs$tur$pay_lyckopla.playNextDrawDialog,
  shouldShowPlayNextDrawDialog = _svs$tur$pay_lyckopla.shouldShowPlayNextDrawDialog,
  payAfterDepositDialog = _svs$tur$pay_lyckopla.payAfterDepositDialog,
  fetchDrawData = _svs$tur$pay_lyckopla.fetchDrawData,
  getDrawData = _svs$tur$pay_lyckopla.getDrawData,
  getCloseTimeDescription = _svs$tur$pay_lyckopla.getCloseTimeDescription,
  handlePayResponse = _svs$tur$pay_lyckopla.handlePayResponse,
  verifySelectedCharities = _svs$tur$pay_lyckopla.verifySelectedCharities,
  trackSuccessfulWagers = _svs$tur$pay_lyckopla.trackSuccessfulWagers;
const _svs$utils$format = svs.utils.format,
  formatCurrency = _svs$utils$format.Currency,
  formatCurrencyFromJupiterString = _svs$utils$format.CurrencyFromJupiterString;
const logger = svs.tur.pay_lyckoplatsen.logger;
function createWagerObject(_ref) {
  let primaryDraw = _ref.primaryDraw,
    secondaryDraw = _ref.secondaryDraw,
    numberOfWeeks = _ref.numberOfWeeks,
    pinLocation = _ref.pinLocation,
    pinLocationType = _ref.pinLocationType,
    lyckoplatsenName = _ref.lyckoplatsenName,
    locationName = _ref.locationName,
    charityId = _ref.charityId,
    isProlongination = _ref.isProlongination,
    wasInvalidCharity = _ref.wasInvalidCharity;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const lng = pinLocation.lng,
    lat = pinLocation.lat;
  const geoBoardData = {
    boardProps: [],
    geoLoc: {
      latitude: lat === null || lat === void 0 ? void 0 : lat.toString().replace('.', ','),
      longitude: lng === null || lng === void 0 ? void 0 : lng.toString().replace('.', ',')
    },
    geoLocType: pinLocationType,
    geoLocName: lyckoplatsenName,
    charityId: charityId && !wasInvalidCharity ? charityId : 0
  };
  if (isSelfService && lyckoplatsenName === svs.tur.lyckoplatsen.utils.getDefaultLocationName() && locationName) {
    geoBoardData.geoLocName = locationName;
  }
  const currentDrawPrimary = primaryDraw.drawNumber;
  const currentDrawSecondary = secondaryDraw.drawNumber;
  const wagers = {
    bets: [{
      productId: 'GEO1',
      drawNum: currentDrawPrimary,
      numDraws: numberOfWeeks,
      betAmountSalesGroup1: formatCurrency(price, true),
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 1,
      geoBoardData
    }, {
      productId: 'GEO2',
      drawNum: currentDrawSecondary,
      numDraws: 0,
      betAmountSalesGroup1: '0,00',
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 0,
      geoBoardData
    }]
  };
  if (isProlongination) {
    wagers.bets[0].betProperties.push('PROLONGATION');
    wagers.bets[1].betProperties.push('PROLONGATION');
  }
  return wagers;
}
function setupPayParam(_ref2) {
  let next = _ref2.next;
  svs.utils.paramHandler.set({
    key: 'pay',
    value: 'true'
  });
  next();
}
function createApiWagers(_ref3) {
  let next = _ref3.next,
    wagers = _ref3.wagers,
    primaryDraw = _ref3.primaryDraw,
    secondaryDraw = _ref3.secondaryDraw;
  const apiWagers = wagers.map(wager => createWagerObject(_objectSpread(_objectSpread({}, wager), {}, {
    primaryDraw,
    secondaryDraw
  })));
  next({
    apiWagers
  });
}
function checkAccountBalance(_ref4) {
  let next = _ref4.next,
    cancel = _ref4.cancel,
    saveState = _ref4.saveState,
    price = _ref4.price,
    product = _ref4.product;
  if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit')) {
    svs.components.account_balance.get(true, balance => {
      if (price > formatCurrencyFromJupiterString(balance)) {
        logger.info("Not enough money. Price: ".concat(price, ", balance: ").concat(balance, ", using after pay dialog"));
        return payAfterDepositDialog({
          cancel,
          balance,
          product,
          price,
          saveState
        });
      }
      next({
        accountBalance: balance
      });
    });
  } else {
    accountServices.accountBalance({
      next,
      cancel,
      saveState,
      price,
      product
    });
  }
}
function numberToWord(number) {
  const words = {
    1: 'ett',
    2: 'två',
    3: 'tre',
    4: 'fyra',
    5: 'fem',
    6: 'sex',
    7: 'sju',
    8: 'åtta',
    9: 'nio',
    10: 'tio'
  };
  return words[number];
}
function pay(_ref5) {
  let data = _ref5.data,
    onDone = _ref5.onDone,
    onError = _ref5.onError,
    onCancel = _ref5.onCancel,
    saveState = _ref5.saveState;
  const product = 'Lyckoplatsen';
  const isMultiWagers = Array.isArray(data);
  let wagers = Array.isArray(data) ? data.map(wager => _objectSpread({}, wager)) : [_objectSpread({}, data)];
  const price = wagers.reduce((totalPrice, wager) => totalPrice + PRICE_PER_WEEK * wager.numberOfWeeks, 0);
  const isAfterDeposit = wagers.some(wager => wager.isAfterDeposit) && svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit');
  const isProlongination = wagers.some(wager => wager.isProlongination);
  const numberOfWeeks = wagers[0].numberOfWeeks;
  let accountBalance;
  let primaryDraw;
  let secondaryDraw;
  let firstDraw;
  let lastDraw;
  let apiWagers;
  let regWagerResults;
  let successfulWagers;
  let failedWagers;
  const calls = [{
    fn: setupPayParam
  }, {
    in: () => ({
      price,
      product
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price,
      product
    }),
    fn: checkAccountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, {
    in: () => ({
      numberOfWeeks
    }),
    fn: getDrawData,
    out: args => {
      var _args2 = args;
      primaryDraw = _args2.primaryDraw;
      secondaryDraw = _args2.secondaryDraw;
      firstDraw = _args2.firstDraw;
      lastDraw = _args2.lastDraw;
      return _args2;
    }
  }, ...(isProlongination ? [{
    in: () => ({
      wagers
    }),
    fn: verifySelectedCharities,
    out: args => {
      var _args3 = args;
      wagers = _args3.wagers;
      return _args3;
    }
  }] : []), {
    in: () => ({
      wagers,
      primaryDraw,
      secondaryDraw
    }),
    fn: createApiWagers,
    out: args => {
      var _args4 = args;
      apiWagers = _args4.apiWagers;
      return _args4;
    }
  }, shouldShowPlayNextDrawDialog({
    params: () => ({
      primaryDraw,
      secondaryDraw,
      wagers
    }),
    calls: () => [{
      in: () => ({
        regCloseTime: firstDraw.regCloseTime
      }),
      fn: playNextDrawDialog
    }]
  }), ...(isAfterDeposit ? [] : [{
    in: () => ({
      price,
      accountBalance,
      product,
      title: "Vill du betala ".concat(numberToWord(wagers.length), " spel p\xE5<br/>").concat(product, " f\xF6r ").concat(price, " kr?"),
      messages: ["Spell\xE4ngd: ".concat(numberOfWeeks, " veckor, ").concat(getLocalizedWeekday(firstDraw.regCloseTime, true, true), " till ").concat(getLocalizedWeekday(lastDraw.regCloseTime, true, true), "."), "".concat(product, " g\xE5r att annullera.")]
    }),
    fn: dialogs.confirmPayment
  }]), function mainPaymentSequence() {
    var _apiWagers;
    if ((_apiWagers = apiWagers) !== null && _apiWagers !== void 0 && _apiWagers.length) {
      return {
        calls: [{
          in: () => ({
            wagers: apiWagers
          }),
          fn: apiCalls.payWagers,
          out: args => {
            var _args5 = args;
            regWagerResults = _args5.regWagerResults;
            return _args5;
          }
        }, {
          in: () => ({
            onError,
            regWagerResults,
            wagers,
            apiWagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => {
            var _args6 = args;
            successfulWagers = _args6.successfulWagers;
            apiWagers = _args6.incompleteWagers;
            failedWagers = _args6.failedWagers;
            return _args6;
          }
        }, mainPaymentSequence]
      };
    }
  }, {
    in: () => ({
      successfulWagers
    }),
    fn: trackSuccessfulWagers
  }, {
    in: () => ({
      product: 'lyckoplatsen'
    }),
    fn: communication.correctionEmail
  }];
  initPay({
    calls,
    saveState,
    cancel: () => {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
      onCancel === null || onCancel === void 0 || onCancel();
    },
    done: () => {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
      if (isMultiWagers) {
        onDone === null || onDone === void 0 || onDone({
          successfulWagers,
          failedWagers
        });
      } else {
        const _successfulWagers$ = successfulWagers[0],
          wager = _successfulWagers$.wager,
          wagerClientSerial = _successfulWagers$.wagerClientSerial;
        onDone === null || onDone === void 0 || onDone({
          wagerId: wagerClientSerial,
          wasInvalidCharity: wager.wasInvalidCharity
        });
      }
    },
    error: error => {
      onError === null || onError === void 0 || onError({
        error
      });
    }
  });
}
async function addToCart(data, onDone) {
  const product = data.product,
    numberOfWeeks = data.numberOfWeeks;
  const drawData = await fetchDrawData(numberOfWeeks);
  const primaryDraw = drawData.primaryDraw;
  data.primaryDraw = primaryDraw;
  data.secondaryDraw = drawData.secondaryDraw;
  const firstDraw = drawData.firstDraw;
  const wagers = createWagerObject(data);
  wagers.bets[0].geoBoardData.reverseGeo = data.locationName;
  wagers.bets[1].geoBoardData.reverseGeo = data.locationName;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const productProperties = {
    wagers,
    isLive: false,
    headers: {
      source: 'SvS:TB:ITS'
    },
    productFlag: product,
    productTitle: product,
    productBrand: product,
    cost: price,
    description: getCloseTimeDescription(firstDraw.regCloseTime)
  };
  const _svs$components$selfs = svs.components.selfserviceCart,
    generateProductItem = _svs$components$selfs.generateProductItem,
    getCartInstance = _svs$components$selfs.getCartInstance;
  const wagerWrapper = generateProductItem(productProperties);
  getCartInstance().actions.addItem(wagerWrapper, error => {
    if (!error) {
      onDone === null || onDone === void 0 || onDone();
    }
  });
}
function makePayment(_ref6) {
  let data = _ref6.data,
    onDone = _ref6.onDone,
    onError = _ref6.onError,
    onCancel = _ref6.onCancel,
    saveState = _ref6.saveState;
  if (isSelfService) {
    addToCart(data, onDone);
  } else {
    pay({
      data,
      onDone,
      onError,
      onCancel,
      saveState
    });
  }
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  makePayment,
  createWagerObject,
  PRICE_PER_WEEK
});

 })(window);